module.exports = __webpack_public_path__ + "static/media/2_en.08f559a5.png";